import React from "react"

const Footer = () => (
  <footer>
    © {new Date().getFullYear()}, Life as Film
  </footer>
)

export default Footer
